export const SettingsPageTab = {
  EditProfile: 'edit-profile',
  Addresses: 'addresses',
  BankAccount: 'bank-account',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type SettingsPageTab = (typeof SettingsPageTab)[keyof typeof SettingsPageTab];
